export const STUDENT_SCORE_WINDOW_MONTHS = 3;
export const STUDENT_REVIEW_DECAY_HALF_LIFE_DAYS = 45;

export type CoordinatorReviewScores = {
  fluencyScore: number;
  presenceScore: number;
  clarityScore: number;
};

export const COORDINATOR_SCORE_WEIGHTS: CoordinatorReviewScores = {
  fluencyScore: 0.5,
  presenceScore: 0.3,
  clarityScore: 0.2,
};

export function coordinatorWeightedScore(
  scores: CoordinatorReviewScores,
): number {
  return (
    scores.fluencyScore * COORDINATOR_SCORE_WEIGHTS.fluencyScore +
    scores.presenceScore * COORDINATOR_SCORE_WEIGHTS.presenceScore +
    scores.clarityScore * COORDINATOR_SCORE_WEIGHTS.clarityScore
  );
}
